import { MailCheck } from "lucide-react";
import { Button } from "@openup/shared/primitives/ui/button";
import { useLogoutMutation } from "@src/queries/auth";

interface SignUpCompleteProps {
  onBackToSignIn: () => void;
}

/**
 * Shown after a successful Google sign-up. The account exists but has no
 * CustomerSuccess role, so it can't enter the app until an administrator
 * grants access. Signing out clears the login cookies that register-code-flow
 * set and returns to the welcome step.
 */
const SignUpComplete = ({ onBackToSignIn }: SignUpCompleteProps) => {
  const logoutMutation = useLogoutMutation();

  const onDone = () => {
    logoutMutation.mutate(undefined, { onSettled: onBackToSignIn });
  };

  return (
    <div className="flex flex-col items-center gap-4 text-center">
      <MailCheck className="h-10 w-10 text-green-700" aria-hidden />
      <p className="text-gray-600" role="alert">
        Your account has been created. An administrator must grant you access
        before you can sign in. Please contact your administrator.
      </p>
      <Button
        variant="ghost"
        size="default"
        onClick={onDone}
        disabled={logoutMutation.isPending}
      >
        Back to sign in
      </Button>
    </div>
  );
};

export default SignUpComplete;
